/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Directives;
    (function (Directives) {
        var ApWaitingMessage = /** @class */ (function () {
            function ApWaitingMessage() {
                this.restrict = 'E';
                this.scope = {
                    isLoading: '=',
                    displayText: '@'
                };
                this.templateUrl = 'app/directives/ap-waiting-message/template.html';
            }
            ApWaitingMessage.factory = function () {
                var directive = function () {
                    return new ApWaitingMessage();
                };
                directive['$inject'] = [];
                return directive;
            };
            ApWaitingMessage.prototype.link = function (scope) {
                scope.displayText = scope.displayText || ap.Constants.translationKeys.directives.loading;
            };
            return ApWaitingMessage;
        }());
        angular
            .module('app')
            .directive('apWaitingMessage', ApWaitingMessage.factory());
    })(Directives = app.Directives || (app.Directives = {}));
})(app || (app = {}));
